module.exports = __webpack_public_path__ + "img/name_input_output_nodes.png";